import { Button } from "./ui/button";
import { TOUR } from "../constants/testIds";
import { Mountain, Globe2, Briefcase, Send, ExternalLink } from "lucide-react";

const badges = [
  { icon: Briefcase, label: "12 лет в туризме" },
  { icon: Globe2, label: "53 страны" },
  { icon: Mountain, label: "Килиманджаро" },
];

export const OwnerSection = () => (
  <section
    id="owner"
    data-testid={TOUR.ownerSection}
    className="bg-cream py-20 sm:py-24"
  >
    <div className="max-w-6xl mx-auto px-5 sm:px-8 grid lg:grid-cols-[minmax(0,1fr)_1.2fr] gap-10 lg:gap-16 items-center">
      <div className="relative order-2 lg:order-1">
        <div className="relative aspect-[4/5] rounded-[2rem] overflow-hidden shadow-2xl max-w-md mx-auto">
          <img
            src="https://customer-assets.emergentagent.com/job_online-tour-finder/artifacts/kbay6i96_image.png"
            alt="Наталья — эксперт по путешествиям"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#063B4E]/50 via-transparent to-transparent" />
          <div className="absolute bottom-5 left-5 right-5 flex flex-wrap gap-2">
            {badges.map(({ icon: Icon, label }) => (
              <div
                key={label}
                className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-white/95 backdrop-blur text-[#063B4E] text-xs font-semibold shadow"
              >
                <Icon className="w-3.5 h-3.5 text-coral" />
                {label}
              </div>
            ))}
          </div>
        </div>
        <div className="absolute -top-4 -right-2 sm:-right-6 bg-coral text-white rounded-2xl px-4 py-3 shadow-xl rotate-3 hidden sm:block">
          <div className="text-[10px] uppercase tracking-widest opacity-90">Личный эксперт</div>
          <div className="font-display text-xl">Наталья</div>
        </div>
      </div>

      <div className="order-1 lg:order-2">
        <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-coral/10 text-coral text-xs uppercase tracking-[0.18em] mb-5">
          Персональный подход
        </div>
        <h2 className="font-display text-4xl sm:text-5xl leading-[1.05] text-[#063B4E]">
          Ваш эксперт по путешествиям
        </h2>

        <div className="mt-6 space-y-4 text-[#3E5060] text-base sm:text-lg leading-relaxed">
          <p>Меня зовут Наталья.</p>
          <p>Я более 12 лет работаю в туристической сфере.</p>
          <p>Лично посетила 53 страны.</p>
          <p>
            Помогаю организовывать семейные путешествия, поездки с детьми,
            молодёжные туры и авторские маршруты.
          </p>
          <p>
            Я восходила на Килиманджаро и веду Telegram-канал, где рассказываю
            о путешествиях, маршрутах и личном опыте.
          </p>
        </div>

        <div className="mt-8 flex flex-wrap gap-3">
          <Button
            data-testid={TOUR.ownerTelegramBtn}
            asChild
            className="bg-teal hover:bg-[#0a616a] text-white rounded-full h-12 px-7 text-base font-semibold shadow-lg shadow-teal/20"
          >
            <a
              href="https://t.me/kudapoedemNatasha"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Send className="w-4 h-4 mr-2" />
              Telegram Натальи
              <ExternalLink className="w-3.5 h-3.5 ml-2 opacity-80" />
            </a>
          </Button>
          <a
            href="tel:+79223831919"
            className="inline-flex items-center h-12 px-6 rounded-full border-2 border-[#063B4E] text-[#063B4E] font-semibold hover:bg-[#063B4E] hover:text-white transition-colors"
          >
            +7 922 383-19-19
          </a>
        </div>
      </div>
    </div>
  </section>
);
